import React, { Fragment, useEffect, useState, useRef } from 'react';
import BiButton from '../controls/BiButton';
import { Alert, Button, Toast } from 'bootstrap';

const BiToast = ({ toastData }) => {

    var [toast, setToast] = useState(false);
    const toastRef = useRef();

    useEffect(() => {
        if (toastData.show == true) {
            var myToast = toastRef.current
            var bsToast = new Toast(myToast)
            bsToast.show();

            myToast.addEventListener('hidden.bs.toast', () => {
                setToast(false)
            });
        }
    }, [toastData]);

    return (

        <div className="toast position-absolute top-0 end-0 m-4" role="alert" ref={toastRef} data-bs-delay="5000">
            <div className="toast-header" style={{ backgroundColor: toastData.error ? "#ffd1d1" :"#81b76b", color:"white" }}>
                <strong className="me-auto">{toastData.header}</strong>
                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div className="toast-body">
                {toastData.desc}
            </div>
        </div>

    );
}

export default BiToast;